<template>
  <SoWidget no-padding no-border plain>
    <div class="d-flex">
      <h4 class="text-h4 mb-10">Complaints</h4>
      <v-spacer />
      <SoCheckbox
        ref="complaints-filter-checkbox"
        v-model="showOpenTickets"
        :label="`Open Complaints`"
      />
    </div>
    <ActivityFeed
      ref="feed"
      :feed-item-list="filteredFeedItems"
      :pagination-reset-key="String(showOpenTickets)"
      :is-loading="isLoading"
      height="calc(100vh - 200px)"
    />
  </SoWidget>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import {
    ActivityFeedItemType,
    IItemsByDate,
  } from "@/models/activityFeed/ActivityFeedItem"
  import { Utility } from "@/types/Utility"
  import { Complaint } from "@/models/complaint/complaint"
  import SoWidget from "@/components/SoWidget.vue"
  import ActivityFeed from "../../timeline/activityFeed/ActivityFeed.vue"
  import SoCheckbox from "@/components/formControls/SoCheckbox.vue"
  import { FreshdeskTicket } from "@/models/freshdeskTicket/freshdeskTicket"

  export default defineComponent({
    components: {
      SoWidget,
      ActivityFeed,
      SoCheckbox,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        showOpenTickets: true,
      }
    },
    computed: {
      filteredFeedItems(): IItemsByDate[] {
        const allowedTypes = new Set([Utility.Complaint])

        return this.current.activityFeedEvents.data
          .map((event) => ({
            date: event.date,
            items: event.items.filter(
              (ticket) =>
                allowedTypes.has(ticket.type) &&
                this.showOpenTicketsFilter(ticket),
            ),
          }))
          .filter((dateGroup) => dateGroup.items.length > 0)
      },
      isLoading() {
        return this.current.activityFeedEvents.isFetching
      },
    },
    methods: {
      showOpenTicketsFilter(event: ActivityFeedItemType): boolean {
        const { item } = event

        if (!this.showOpenTickets) {
          return true
        }

        if (item instanceof FreshdeskTicket) {
          return item.isOpen
        }

        if (item instanceof Complaint) {
          return !item.isClosed
        }

        return false
      },
    },
  })
</script>
